import React from "react";
import { PrivacyPolicy } from "../components";
import { PrivacyHeaderContainer } from "../containers/privacyHeader";
import { FooterContainer } from "../containers/footer";

export default function privacyPage() {
  return (
    <div>
      <PrivacyHeaderContainer />
      <PrivacyPolicy>
        <PrivacyPolicy.InfoContainer>
          {" "}
          <PrivacyPolicy.Heading>Privacy Policy</PrivacyPolicy.Heading>
          <PrivacyPolicy.Text>
            Bits takes your privacy and security seriously, and we commit
            ourselves to maintain your trust and confidence.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Contact Us</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us at info@bitechqa.com.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Transparency</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We want to explain to you as clearly and transparently as we can how
            we use information we collect and receive about you.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>Our Privacy Policy explains:</PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            The categories of data we collect about you and why we collect them.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            How we use that data to provide a more customized experience that
            you’ll find valuable.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            How and why we receive or share your personal data.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            How and where you can exercise more control over the use of your
            data and exercise your individual rights.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>General</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            Vms International operates the dash.ezyvms.com website and mobile
            app.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            This page is used to inform website and app visitors regarding our
            policies with the collection, use, and disclosure of Personal
            Information if anyone decided to use our Service, the Bits website
            and app.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing and improving the
            Service. We will not use or share your information with anyone
            except as described in this Privacy Policy.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>
            Information Collection and Use
          </PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            For a better experience, while using our Service, we may require you
            to provide us with certain personally identifiable information,
            including but not limited to your name, phone number, and email
            address. The information that we collect will be used to contact or
            identify you.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Log Data</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We want to inform you that whenever you visit our Service, we
            collect information that your browser sends to us that is called Log
            Data. This Log Data may include information such as your computer’s
            Internet Protocol ("IP") address, browser version, pages of our
            Service that you visit,the time and date of your visit, the time
            spent on those pages, and other statistics.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Cookies</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            Cookies are files with small amount of data that is commonly used an
            anonymous unique identifier. These are sent to your browser from the
            website that you visit and are stored on your computer’s hard drive.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Service Providers</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We may employ third-party companies and individuals due to the
            following reasons:
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>To facilitate our Service;</PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            To provide the Service on our behalf;
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            To perform Service-related services; or
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            To assist us in analyzing how our Service is used
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            We want to inform our Service users that these third parties have
            access to your Personal Information.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            The reason is to perform the tasks assigned to them on our behalf.
            However, they are obligated not to disclose or use the information
            for any other purpose.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Security</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We value your trust in providing us your Personal Information, thus
            we are striving to use commercially acceptable means of protecting
            it. But remember that no method of transmission over the internet,
            or method of electronic storage is 100% secure and reliable, and we
            cannot guarantee its absolute security.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>
            Links to Other Sites
          </PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            Our Service may contain links to other sites. If you click on a
            third-party link, you will be directed to that site. Note that these
            external sites are not operated by us. Therefore, we strongly advise
            you to review the Privacy Policy of these websites. We have no
            control over, and assume no responsibility for the content, privacy
            policies, or practices of any third-party sites or services.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>
            Children’s Privacy
          </PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            Our Services do not address anyone under the age of 13. We do not
            knowingly collect personal identifiable information from children
            under 13. In the case we discover that a child under 13 has provided
            us with personal information,we immediately delete this from our
            servers. If you are a parent or guardian and you are aware that your
            child has provided us with personal information, please contact us
            so that we will be able to do necessary actions.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>
            Changes to This Privacy Policy
          </PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We may update our Privacy Policy from time to time. Thus, we advise
            you to review this page periodically for any changes. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            These changes are effective immediately, after they are posted on
            this page.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Customer Control</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We respect your individual customer rights and give you control over
            how your customer data is used.You can:
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            Request to update your account and manage your email communication
            settings
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            Request access and make corrections to your personal data.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            Request that we delete your personal data.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            Request to restrict processing of your personal data.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.Text>
            Object to processing of your personal data.
          </PrivacyPolicy.Text>
          <PrivacyPolicy.SubHeading>Accountability</PrivacyPolicy.SubHeading>
          <PrivacyPolicy.Text>
            We hold ourselves accountable to meeting our high standards for
            privacy and data security.
          </PrivacyPolicy.Text>
        </PrivacyPolicy.InfoContainer>
      </PrivacyPolicy>
      <FooterContainer />
    </div>
  );
}
